import { Button, FormControl, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Table, TableContainer, Tbody, Td, Th, Thead, Tr, useDisclosure, useToast } from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


const TeachersTable = ({ data, search, loading, setFetchAgain }) => {
	const { isOpen, onOpen, onClose } = useDisclosure()
	const [id, setId] = useState("");
	const [teacherId, setTeacherId] = useState("");
	const [teacherName, setTeacherName] = useState("");
	const [dob, setDob] = useState("");
	const [nationality, setNationality] = useState("");
	const [phone, setPhone] = useState("");
	const [email, setEmail] = useState("");
	const [pres, setPres] = useState(false);
	const [dis, setDis] = useState(false);
	const [picLoading, setPicLoading] = useState(true);

	const { user } = ChatState();

	const toast = useToast();

	const openModal = (teacherinfo) => {
		setId(teacherinfo ? teacherinfo._id : "");
		setTeacherId(teacherinfo ? teacherinfo.teacherId : "");
		setTeacherName(teacherinfo ? teacherinfo.teacherName : "");
		setNationality(teacherinfo ? teacherinfo.nationality : "");
		setDob(teacherinfo ? new Date(teacherinfo.dob).toLocaleDateString() : "");
		setPhone(teacherinfo ? teacherinfo.phone : "");
		setEmail(teacherinfo ? teacherinfo.email : "");
		setPres(teacherinfo ? teacherinfo.pres : false);
		setDis(teacherinfo ? teacherinfo.dis : false);
		setPicLoading(false);
		onOpen()
	}

	const deleteTeacher = async (id) => {


		try {
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
				params: { id: id }

			};

			await axios.delete(
				'/api/teacher',
				config
			);

			toast({
				title: "Supprimé avec succès",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			setFetchAgain(true);
		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
		}
	}



	const updateTeacher = async () => {
		if (!teacherId || !teacherName || !dob || !nationality || !phone || !email) {
			toast({
				title: "Veuillez remplir tous les champs",
				status: "warning",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			setPicLoading(false);
			return;
		}
		setPicLoading(true);

		try {
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
			};
			await axios.put(
				"/api/teacher",

				{
					id,
					teacherId,
					teacherName,
					dob,
					nationality,
					phone,
					email,
					pres,
					dis
				},
				config
			);

			toast({
				title: "Mise à jour réussie",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});


			//  history.push("/chats");
			setFetchAgain(true);



		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});

		}
		onClose();
	};


	return (
		<>
			{/* <Button ml={4} ref={finalRef}>
        I'll receive focus on close
    </Button> */}

			<Modal
				//initialFocusRef={initialRef}
				// finalFocusRef={finalRef}
				isOpen={isOpen}
				onClose={onClose}
			>
				<ModalOverlay />
				<ModalContent m='auto'>
					<ModalHeader className="bg-gray-50 shadow-md text-black text-xl"><i className="fa-solid fa-user-large text-xl ml-1"></i> Professeur</ModalHeader>

					<ModalBody pb={6}>

						<div className="flex mt-5">
							<div className="mr-4">
								<FormControl >
									<Input id='name' placeholder='Id' value={teacherId}
										onChange={(e) => setTeacherId(e.target.value)} />
								</FormControl>

								<FormControl mt={2}>
									<Input id='name' placeholder='Nom et Prenom' value={teacherName}
										onChange={(e) => setTeacherName(e.target.value)} />
								</FormControl>

								<FormControl mt={4}>
									<Input placeholder='Date de naissance' id='dob' value={dob}
										onChange={(e) => setDob(e.target.value)} />
								</FormControl>

								<FormControl mt={4}>
									<Input placeholder='Nationality' id='nationality' value={nationality}
										onChange={(e) => setNationality(e.target.value)} />
								</FormControl>




							</div>
							<div>
								<FormControl>

									<Input placeholder='Telephone' id='yearsOf' value={phone}
										onChange={(e) => setPhone(e.target.value)} />
								</FormControl>
								<FormControl mt={4}>

									<Input placeholder='Email' id='yearsOf' value={email}
										onChange={(e) => setEmail(e.target.value)} />
								</FormControl>

								<div className="flex mt-4">
									<FormControl mr="2">
									presential
										<Input type="checkbox" id='pres' checked={pres}
											onChange={(e) => setPres(e.target.checked)} /> 
									</FormControl>
									<FormControl ml="2">
									a Distance
										<Input className="" type="checkbox" id='dis' checked={dis}
											onChange={(e) => setDis(e.target.checked)} />
									</FormControl>
								</div>
							</div>

						</div>

					</ModalBody>

					<ModalFooter>
						<Button colorScheme='blue' mr={3}
							onClick={updateTeacher}
							isLoading={picLoading}>
							Enregistrer
						</Button>
						<Button onClick={onClose}>Annuler</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
			<TableContainer w={"full"} className='border'>
				<Table variant={"simple"} >

					<Thead>
						<Tr className="bg-gray-50 text-black">
							<Th w={"24"}></Th>
							<Th textAlign={"center"}>id</Th>
							<Th textAlign={"center"}>Nom et Prenom</Th>
							<Th textAlign={"center"}>Date de Naissance</Th>
							<Th textAlign={"center"}>Nationality</Th>
							<Th textAlign={"center"}>Telephone</Th>
							<Th textAlign={"center"}>Email</Th>
							<Th textAlign={"center"}>presential</Th>
							<Th textAlign={"center"}>Distance</Th>

						</Tr>
					</Thead>
					<Tbody >

						{data?.filter((teacher) => {
							return search.toLowerCase() === ''
								? teacher
								: teacher.teacherName.toLowerCase().includes(search.toLowerCase());
						})
							.map((teacher, index) => (

								<Tr key={index} fontSize="sm">
									<Td >
										{/* <User_crud tittle='edit' teacherinfo={teacher} setFetchAgain={setFetchAgain} /> */}
										<Button bg='gray.50' onClick={() => { openModal(teacher) }}> <i className="fa-regular fa-pen-to-square text-blue-400 mr-2"></i> Modifier
										</Button>

										<Button fontSize={14} ml={2} bg='gray.50' onClick={() => deleteTeacher(teacher._id)}  ><i className="fa-solid fa-trash text-red-500"></i></Button>
									</Td>
									<Td textAlign={"center"}>{teacher.teacherId}</Td>
									<Td textAlign={"center"}>{teacher.teacherName}</Td>
									<Td textAlign={"center"}>{new Date(teacher.dob).toLocaleDateString()}</Td>
									<Td textAlign={"center"}>{teacher.nationality}</Td>
									<Td textAlign={"center"}>{teacher.phone}</Td>
									<Td textAlign={"center"}>{teacher.email}</Td>
									<Td textAlign={"center"}>{
										teacher.pres == true ?
											<i className="fa-solid fa-check text-green-500"></i>
											: <i className="fa-solid fa-xmark text-red-500"></i>

									}</Td>
									<Td textAlign={"center"}>{
										teacher.dis == true ?
											<i className="fa-solid fa-check text-green-500"></i>
											: <i className="fa-solid fa-xmark text-red-500"></i>

									}</Td>


								</Tr>

							))}


					</Tbody>


				</Table>
				<div className="w-full  flex item-center p-6">
					{loading && <i className="fa-solid fa-circle-notch animate-spin m-auto text-xl"></i>}
					{!loading && data.length === 0 && <span className="text-md text-gray-300 m-auto">Aucun résultat.</span>}
				</div>
			</TableContainer>
		</>
	);


};

export default TeachersTable;
